import { useEffect } from 'react';
import { devLog } from '../utils/devLog';

export function useLogChange(label, values) {
  const serialized = JSON.stringify(values);
  useEffect(() => {
    devLog(label + ' changed -', ...(Array.isArray(values) ? values : [values]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [label, serialized]);
}
